import styled, { CSSProperties, css } from "styled-components"
import { device } from "../styles/stylesConfig"
import { memo, useContext } from "react";
import { ThemeContext } from "../contexts/theme/ThemeContext";

const TitleContainer = styled.div<{ color: string; subcolor: string; secondarytitle: string | undefined }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    position: relative;
    margin-bottom: 60px;

    h1 {
        width: 90%;
        font-size: 34px;
        text-transform: uppercase;
        color: #2E2D2D;
        color: ${({ color }) => color};
        text-align: center;

        @media ${device.md} {
            font-size: 28px;
        }

        @media ${device.sm} {
            font-size: 24px;
        }

        @media ${device.xs} {
            font-size: 18px;
        }

        ${({ secondarytitle }) => secondarytitle === 'true' && css`
            font-size: 28px;

            @media ${device.md} {
                font-size: 24px;
            }

            @media ${device.sm} {
                font-size: 20px;
            }

            @media ${device.xs} {
                font-size: 16px;
            }
        `}

    }

    p {
        width: 90%;
        color: #2E2D2D;
        color: ${({ subcolor }) => subcolor};
        margin-top: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;

        @media ${device.lg} {
            /* width: 65%; */
            width: 85%;
        }

        @media ${device.md} {
            width: 85%;
        }

        @media ${device.sm} {
            font-size: 12px;
            line-height: 24px;
            width: 90%;
        }

    }
    
    @media ${device.sm} {
        margin-bottom: 50px;
    }

`

interface Props {
    title: string;
    subtitle?: string;
    textAlign?: 'start' | 'center' | 'end',
    titleColor?: string;
    titleLighter?: boolean;
    titleStyle?: CSSProperties;
    style?: CSSProperties;
    isSecondaryTitle?: boolean;
}

const TitleComponent = ({ title, subtitle, textAlign, titleColor, titleLighter, titleStyle, style, isSecondaryTitle }: Props) => {

    const {
        theme: { colors },
    } = useContext(ThemeContext);

    return (

        <TitleContainer color={colors.text} subcolor={colors.text_light} style={{ ...style }} className="utils__fade-in-fast-top" secondarytitle={isSecondaryTitle?.toString()}>

            <h1 style={{ textAlign, color: titleColor, fontWeight: titleLighter ? 'normal' : 'bold', ...titleStyle }} className="utils__fade-in-fast-top" dangerouslySetInnerHTML={{ __html: title }} />

            {subtitle && <p style={{ textAlign }} className="utils__fade-in-fast-top">{subtitle}</p>}

        </TitleContainer>

    )
}

const Title = memo(TitleComponent);

export default Title;